export default __webpack_public_path__ + "static/media/nwCorp_v035.8fda8106.jpg";